import { Component, Input, OnInit } from "@angular/core";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
})
export class MainComponent implements OnInit {
  signUp: boolean = false;
  login: boolean = false;
  language: any = '';
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.login = true;
    setTimeout(() => {
      this.commonService.getSelectedLang.subscribe(l => {
        if (l) {
          this.language = l;
        } else {
          this.language = ''
        }
      })
    }, 0);
    // localStorage.clear();
  }

  isSignUp(e: any) {
    this.signUp = e;
  }



}
